import { computed, type Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { fetchComplianceMappings } from './report.endpoints';
import type { TComplianceMappingsPayload } from '../models/types';

export function useFetchComplianceMappings(payloadRef: Ref<TComplianceMappingsPayload | null>) {
  return useQuery({
    queryKey: computed(() => [
      'complianceMappings',
      payloadRef.value?.vulnerabilityUid,
      payloadRef.value?.integrationId,
    ]),
    queryFn: () => fetchComplianceMappings(payloadRef.value!),
    enabled: computed(() => !!payloadRef.value?.vulnerabilityUid && !!payloadRef.value?.integrationId),
  });
}
